import { type Props as ReactModalProps } from 'react-modal';

import { Modal } from '../../../components/ToolkitV2/Modal/Modal';
import { Text } from '../../../components/ToolkitV2/Text/Text';

import { defaultTheme } from 'styled-system';

import * as Styled from './MakeModelKeywordSearchModal.styled';

type MakeModelKeywordSearchModalProps = Pick<
  ReactModalProps,
  'onRequestClose' | 'isOpen'
>;

export const MakeModelKeywordSearchModal = (
  props: MakeModelKeywordSearchModalProps,
) => {
  const { onRequestClose, ...rest } = props;

  const MODAL_NAME = 'Make Model Keyword Search Modal';

  return (
    <Modal
      borderRadius={`${defaultTheme.borderRadius.default} ${defaultTheme.borderRadius.default} 0 0`}
      padding="0"
      height="100%"
      width="100%"
      contentLabel={MODAL_NAME}
      modalClassName="make-model-keyword-search"
      onRequestClose={onRequestClose}
      {...rest}
    >
      <Styled.Header onClick={onRequestClose} aria-label="Close modal">
        <Text size="M16" weight="bold" color="GREY_DARKER">
          Make & model
        </Text>
        <Styled.HeaderIcon />
      </Styled.Header>
    </Modal>
  );
};
